module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Summit Institute","short_name":"Summit Institute","start_url":"/","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3e189294032544466c9dc15da795ba83"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
